import type { SiteCreateRequest, SiteEntity } from '@common/types/site.type';
import type { Template } from '@common/types/template.type';
import type { SiteState } from './site.reducer';
import { WEBSITE_SITE_FEATURE_KEY } from './site.reducer';
import type { WebsiteState } from '../website-feature.reducer';

import { createSelector } from '@ngrx/store';

import { ELanguages, ESiteStatuses } from '@common/enums';
import { websiteState } from '../website-state.selectors';

export const selectSiteState = createSelector(
    websiteState,
    (state: WebsiteState): SiteState => state[WEBSITE_SITE_FEATURE_KEY]
);

export const selectSite = createSelector(selectSiteState, (state: SiteState): SiteEntity => state?.site);
export const selectTemplate = createSelector(selectSiteState, (state: SiteState): Template => state?.site as any);
export const selectSiteId = createSelector(selectSite, (site: SiteEntity) => site?.id);
export const selectSiteName = createSelector(selectSite, (site: SiteEntity): string => site?.name);
export const selectNewSiteData = createSelector(
    selectSiteState,
    (state: SiteState): Partial<SiteCreateRequest> => state.newSiteData
);
export const selectSiteSaving = createSelector(selectSiteState, (state: SiteState): boolean => state.saving);
export const selectLanguage = createSelector(
    selectTemplate,
    (site: Template): ELanguages => site?.lang || ELanguages.EN
);
export const selectSiteIsNew = createSelector(
    selectSite,
    (site: SiteEntity): boolean => site?.status === ESiteStatuses.New
);
export const selectSiteIsActive = createSelector(
    selectSite,
    (site: SiteEntity): boolean => site?.status === ESiteStatuses.Active
);
export const selectSiteIsPublished = createSelector(selectSite, (site: SiteEntity): boolean => Boolean(site?.pub_date));
export const selectSiteAvailablePageCount = createSelector(
    selectSite,
    (site: SiteEntity): number => site?.available_page_count
);

export const selectSitePublishedDate = createSelector(selectSite, (site: SiteEntity): string => site?.pub_date);
